// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcrumb_breadcrumbs__MaEZh"};